import * as yup from 'yup';

import { isDateValid } from 'utils';

import { emailRegExp } from './emailValidation';

export const passwordRegExp =
  /^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z])[A-Za-z0-9@$%*!#?&^_]*$/;

const passwordValidation = yup
  .string()
  .matches(passwordRegExp, 'Password is not valid')
  .min(8)
  .required('Password is required');

export const createPassSchema = yup.object({
  password: passwordValidation,
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password'), ''], 'Passwords must match')
    .required()
});

export const signInSchema = yup.object({
  value: yup.string().required('Username / Email field is required'),
  password: yup.string().min(1).required('Password is required'),
  rememberMe: yup.boolean().notRequired()
});

export const createAccountSchema = (
  isReferalFlow?: boolean,
  isPolicyAcceptRequired?: boolean
) =>
  yup.object({
    email: yup
      .string()
      .matches(emailRegExp, 'Email is not valid')
      .required('Email is required'),
    givname: yup.string().required('First Name is required'),
    surname: yup.string().required('Last Name is required'),
    ph_mobile: yup.string().required('Phone number is required'),
    bday_date: yup
      .string()
      .transform((originalValue) => originalValue.trim())
      .test('valid-date', 'Invalid date format or date', (value) =>
        isDateValid(value)
      )
      .required('Birthday is required'),
    postal: isReferalFlow
      ? yup.number().notRequired()
      : yup.number().required('Postal is required'),
    ref_code: yup.string(),
    campaign_id: yup.string(),
    gender: isReferalFlow
      ? yup
          .mixed()
          .test(
            'gender-required',
            'Gender is required',
            (value) => value !== null
          )
      : yup.string().nullable().notRequired(),
    policyAccepted: isPolicyAcceptRequired
      ? yup.boolean().oneOf([true], 'You must accept the cancellation policy')
      : yup.boolean().notRequired()
  });

export const resetPasswordSchema = yup.object({
  value: yup
    .string()
    .min(2, 'Member Number / Email must be at least 2 characters')
    .required('Member Number / Email field is required'),
  bday_date: yup
    .string()
    .transform((originalValue) => originalValue.trim())
    .test('valid-date', 'Invalid date format or date', (value) =>
      isDateValid(value)
    )
    .required('Birthday is required')
});
